<script setup>
import MainHeader from "@/views/layouts/main/MainHeader.vue";
import {useRoute} from "vue-router";
import {computed} from "vue";
import MainFooter from "@/views/layouts/main/MainFooter.vue";
import LoginModal from "@/components/auth/LoginModal.vue";

const currentRoute = useRoute();

const containerId = computed(() => {
  if (!currentRoute.name) {
    return (Math.random() + 1).toString(36).substring(7);
  }
  return currentRoute.name.replaceAll('.', '_') + '-page';
});

const routeKey = computed(() => {
  if (!currentRoute.name) {
    return (Math.random() + 1).toString(36).substring(7);
  }
return currentRoute.name + JSON.stringify(currentRoute.params);
});

</script>

<template>
  <MainHeader />
  <main :id="containerId">
    <RouterView :key="routeKey"/>
  </main>
  <MainFooter />
<!--  <router-view :key="$route.path" />-->
  <LoginModal/>
</template>
